export const categories = [
    {
      "categoryId": -1,
      "sourceCategory": "All"
    },
    {
      "categoryId": 1,
      "sourceCategory": "Academia & Scholarly Resources"
    },
    {
      "categoryId": 2,
      "sourceCategory": "Global News"
    },
    {
      "categoryId": 4,
      "sourceCategory": "Periodicals & Specialty News"
    },
    {
      "categoryId": 5,
      "sourceCategory": "US Government"
    },
    {
      "categoryId": 6,
      "sourceCategory": "Intergovernmental Organizations"
    },
    {
      "categoryId": 7,
      "sourceCategory": "Think Tanks"
    },
    {
      "categoryId": 8,
      "sourceCategory": "Other Selected Sources"
    }
  ]